<template>
  <div>
    <div class="contents">
      <b-form @submit="onSubmit">
        <div class="row g-0 table-type header-col">
          <div class="col-sm-4">
            {{ $t("title.common.status") }}
          </div>
          <div class="col-sm-8">
            <select class="form-select-lg" v-model="memberinfo.status">
              <option value="1">{{ $t("filter.membership.ok") }}</option>
              <option value="2">{{ $t("filter.membership.delete") }}</option>
            </select>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.id") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0">{{ memberinfo.id }}</p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.nickname") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0">
              <MemberInfo
                :nickname="memberinfo.nickname"
                :playerno="memberinfo.player_pk"
              />
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.first_name") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0 text-break">
              {{ memberinfo.firstname }}
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.last_name") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0 text-break">
              {{ memberinfo.lastname }}
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.email") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0 text-break">
              <a :href="'mailto:' + memberinfo.email">{{ memberinfo.email }}</a>
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.country") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0 text-break">
              {{ country.countryname }}
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.state") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0 text-break">{{ states.statesdesc }}</p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.time_zone") }}
          </div>
          <div class="col-sm-8">
            <p
              class="d-table-cell ps-0 text-break"
              v-if="Object.keys(timezone).length"
            >
              {{ timezone.timezonelist_name }}
              (UTC
              {{
                timezone.timezonelist_offset >= 0
                  ? "+" + timezone.timezonelist_offset
                  : timezone.timezonelist_offset
              }}:00)
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.handicap") }}
          </div>
          <div class="col-sm-8 d-block">
            <div class="row row-cols-1 row-cols-sm-2 gx-2 gy-3">
              <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.common.automation") }}
                  {{ $t("title.common.handicap") }}
                </p>

                <input
                  type="text"
                  class="form-control"
                  v-model="memberinfo.handi_9"
                  readonly
                />
              </div>
              <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.common.activation") }}
                  {{ $t("title.common.handicap") }}
                </p>
                <div class="input-group">
                  <input
                    type="text"
                    v-model="handicap_form.handicap_index_"
                    readonly
                    class="form-control"
                  />

                  <button
                    class="btn btn-primary btn-lg icon-check"
                    type="button"
                    @click="get_modal_handicap"
                  >
                    {{ $t("button.common.view") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.certification") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0">
              {{
                memberinfo.membertype === "1"
                  ? $t("text.common.certified")
                  : $t("text.common.uncertified")
              }}
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.email_agree") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0">
              {{
                memberinfo.emailagree === "1"
                  ? $t("text.common.agree")
                  : $t("text.common.no_agree")
              }}
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.gender") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0">
              {{
                memberinfo.gender === "M"
                  ? $t("text.common.male")
                  : $t("text.common.female")
              }}
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.handedness") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0">
              {{
                memberinfo.handrl === "R"
                  ? $t("title.common.right")
                  : $t("title.common.left")
              }}
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.tee_height") }}
          </div>
          <div class="col-sm-8">
            <p class="d-table-cell ps-0">
              {{ memberinfo.teeheight | comma }}mm
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.setting") }}
          </div>
          <div class="col-sm-8 d-block">
            <div class="row">
              <div class="col-md">
                <p class="d-table-cell ps-0">
                  {{ $t("title.membership.fairway") }} :
                  {{ change_fieldunit(memberinfo.fieldunit) }}
                </p>
              </div>
              <div class="col-md">
                <p class="d-table-cell ps-0">
                  {{ $t("title.membership.green") }} :
                  {{ change_greenunit(memberinfo.greenunit) }}
                </p>
              </div>
              <div class="col-md">
                <p class="d-table-cell ps-0">
                  {{ $t("title.membership.speed") }} :
                  {{ change_speedunit(memberinfo.speedunit) }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            :aria-label="$t('button.common.list')"
            @click="
              $router.push({
                name: 'MemberList',
              })
            "
            >{{ $t("button.common.list") }}</b-button
          >
          <b-button
            size="xl"
            variant="primary"
            :aria-label="$t('button.common.save')"
            type="submit"
            >{{ $t("button.common.save") }}</b-button
          >
        </div>
      </b-form>
    </div>
    <b-modal
      id="modal-handicap-reg"
      ref="modal-handicap-reg"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("page.membership.x_handicap") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-handicap-reg'].hide()"
        ></b-button>
      </template>
      <h6 class="modal-subtitle">{{ memberinfo.nickname }}'s Handicap</h6>

      <b-table-simple responsive class="scoreboard mb-4">
        <b-tbody v-if="handiscorecnt > 0">
          <b-tr>
            <!-- <b-th rowspan="4">{{ $t("title.common.player") }}</b-th> -->
            <b-th sticky-column>{{ $t("title.common.date") }}</b-th>
            <template v-for="(val, idx) in handiscore">
              <b-td :key="idx" :colspan="val.length" class="text-date">{{
                val[Object.keys(val)[0]].regdate | dateformat("YYYY-MM-DD")
              }}</b-td>
            </template>
          </b-tr>

          <b-tr>
            <b-th sticky-column>{{ $t("title.common.play_format") }}</b-th>
            <template v-for="(val, idx) in handiscore">
              <b-td :key="idx" :colspan="val.length"
                >{{ val[Object.keys(val)[0]].holecount }}H</b-td
              >
            </template>
          </b-tr>

          <b-tr>
            <b-th sticky-column>{{ $t("title.common.subcourse") }}</b-th>
            <template v-for="(val, idx) in handiscore">
              <template v-for="(val_, idx_) in val">
                <b-td
                  v-if="handiscore.length == idx + 1 && val.length == idx_ + 1"
                  :key="idx + idx_"
                  v-b-popover.hover.left="val_.title"
                  class="text-nowrap"
                >
                  {{ val_.description }}
                </b-td>
                <b-td
                  v-else
                  :key="idx + idx_"
                  v-b-popover.hover.top="val_.title"
                  class="text-nowrap"
                >
                  {{ val_.description }}
                </b-td>
              </template>
            </template>
          </b-tr>

          <b-tr>
            <b-th sticky-column>{{ $t("title.common.round") }}</b-th>
            <template v-for="(val, idx) in Array(handiscorecnt)">
              <b-td :key="idx"
                >{{
                  idx == 0
                    ? "Oldest"
                    : idx + 1 == handiscorecnt
                    ? "Newest"
                    : idx + 1
                }}
              </b-td>
            </template>
          </b-tr>
          <b-tr>
            <!-- <b-th>{{ memberinfo.nickname }}</b-th> -->
            <b-th sticky-column>{{ $t("title.common.score") }}</b-th>
            <template v-for="(val, idx) in handiscore">
              <template v-for="(val_, idx_) in val">
                <b-td :key="idx + idx_">
                  <span
                    :class="
                      handiscore_limit.find((v) => v.score_pk == val_.score_pk)
                        ? 'rounded-circle'
                        : ''
                    "
                    >{{ val_.score - val_.base_par }}
                  </span>
                </b-td>
              </template>
            </template>
          </b-tr>
        </b-tbody>
        <b-tbody v-else>
          <tr>
            <td class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </b-tbody>
      </b-table-simple>

      <div class="row g-3">
        <div class="col-sm-12 col-lg-6">
          <p class="mb-2 fw-500 fs-14 text-black">
            {{ $t("title.common.automation") }}
            {{ $t("title.common.handicap") }}
          </p>

          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="handicap_form.handicap_auto"
              readonly
            />
            <!-- <button
              class="btn btn-primary btn-lg icon-check"
              type="button"
              @click="
                handicap_form.handicap_index_ = hc_au(
                  handicap_form.handicap_auto
                )
              "
            >
              {{ $t("button.common.apply") }}
            </button> -->
          </div>
        </div>
        <div class="col-sm-12 col-lg-6">
          <p class="mb-2 fw-500 fs-14 text-black">
            {{ $t("title.common.activation") }}
            {{ $t("title.common.handicap") }}
          </p>
          <input
            type="text"
            v-model="handicap_form.handicap_index_"
            class="form-control"
            readonly
          />
        </div>

        <!-- <div class="col-sm-12 col-lg-4">
          <p class="mb-2 fw-500 fs-14 text-black">
            {{ $t("title.common.confirm_by") }}
          </p>

           <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="handicap_form.writer"
            />
            <button
              class="btn btn-primary btn-lg icon-check"
              type="button"
              @click="set_playerhandicap(memberinfo.player_pk)"
            >
              {{ $t("button.common.confirm") }}
            </button>
          </div>
        </div> -->
        <p class="mt-2 text-subscript">
          {{ $t("text.membership.hc_base_9_hole") }}
        </p>
      </div>

      <template #modal-footer>
        <b-button
          type="button"
          class="btn btn-outline-secondary btn-md"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-handicap-reg'].hide()"
        >
          {{ $t("button.common.close") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/member";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "MemberView",
  data() {
    return {
      playerno: this.$route.params.playerno,

      memberinfo: {
        id: "",
        nickname: "",
        firstname: "",
        lastname: "",
        email: "",
        membertype: "",
        timezone: "",
        daylighttime: "",
        gender: "",
        hand: "",
        teeheight: "",
        fieldunit: "",
        greenunit: "",
        speedunit: "",
        emailagree: "",
        status: "",
        handi_9: 0,
        handicap_index: 0,
        countryno: 0,
        statesno: 0,
      },
      handicap_form: {
        handicap_index: 0,
        handicap_index_: 0,
        handicap_auto: 0,
        writer: this.$store.state.userId,
      },
      handiscore: [],
      handiscore_limit: [],
      handiscorecnt: 0,
      country: [],
      states: [],
      timezone: [],
      timezonelist: [],
      countrylist: [],
      stateslist: [],
    };
  },
  methods: {
    get_countrylist() {
      ax.get_countrylist((flag, data) => {
        if (flag) {
          this.countrylist = data.countrylist;
        } else {
          alert(data);
        }
      });
    },
    get_timezonelist() {
      ax.get_timezonelist((flag, data) => {
        if (flag) {
          this.timezonelist = data.timezonelist;
          this.get_adminplayerinfo();
        } else {
          alert(data);
        }
      });
    },
    get_stateslist() {
      ax.get_stateslist(this.memberinfo.countryno, (flag, data) => {
        if (flag) {
          this.stateslist = data.stateslist;

          this.states = this.stateslist.find(
            (v) => v.statesno == this.memberinfo.statesno
          );

          console.log("states_list", this.stateslist);
        } else {
          alert(data);
        }
      });
    },
    get_adminplayerinfo() {
      ax.get_adminplayerinfo(this.playerno, (flag, data) => {
        //console.log(flag, data);
        if (flag) {
          this.memberinfo = data.memberinfo;
          this.handicap_form.handicap_index = this.memberinfo.handicap_index;
          this.handicap_form.handicap_index_ = this.hc_au(
            this.memberinfo.handicap_index
          );
          this.handicap_form.handicap_auto = this.memberinfo.handi_9;
          this.handiscore = data.handiscore;
          this.handiscore_limit = data.handiscore_limit;
          this.handiscorecnt = data.handiscorecnt;

          console.log("this.timezonelist", this.timezonelist);
          if (
            this.timezonelist.find(
              (v) => v.timezonelist_pk == this.memberinfo.timezone
            )
          )
            this.timezone = this.timezonelist.find(
              (v) => v.timezonelist_pk == this.memberinfo.timezone
            );

          if (
            this.countrylist.find(
              (v) => v.countryno == this.memberinfo.countryno
            )
          )
            this.country = this.countrylist.find(
              (v) => v.countryno == this.memberinfo.countryno
            );
          if (this.memberinfo.countryno > 0) this.get_stateslist();
          // if (this.memberinfo.statesno) this.get_citylist();
        } else {
          alert(data);
        }
      });
    },
    get_modal_handicap() {
      this.$refs["modal-handicap-reg"].show();
      this.get_adminplayerinfo();
    },
    onSubmit(event) {
      event.preventDefault();

      ax.set_adminplayeredit(this.playerno, this.memberinfo, (flag, data) => {
        alert(data.message);
        //console.log(flag, data);
        if (flag) {
          this.get_adminplayerinfo();
        } else {
          return false;
        }
      });
    },
    set_playerhandicap() {
      this.handicap_form.handicap_index = this.strip_hc_au(
        this.handicap_form.handicap_index_
      );
      ax.set_playerhandicap(this.playerno, this.handicap_form, (flag, data) => {
        alert(data.message);
        this.$refs["modal-handicap-reg"].hide();
        //console.log(flag, data);
        if (flag) {
          this.get_adminplayerinfo();
        } else {
          return false;
        }
      });
    },
  },
  created() {
    this.get_countrylist();
    this.get_timezonelist();
  },
  mixins: [myMixin],
};
</script>
<style scoped>
.active {
  color: #35383b;
}
</style>
